import * as React from 'react';
import Breadcrumbs from '../../containers/Breadcrumbs';
import SelectionClearer from '../../containers/Selection/Clearer';
import { PageTitle } from './styles';

import { Translate } from 'react-redux-i18n';

interface TitleProps {
	title?: string;
	hasBreadCrumbs: boolean;
	hasClearButton: boolean;
}

const Title = (props: TitleProps) => {
	const { hasBreadCrumbs, hasClearButton, title } = props;

	return (
		<>
			{hasBreadCrumbs
				? <Breadcrumbs />
				: <PageTitle className="PageTitle" hasClearButton={hasClearButton}>
					{title &&
						<>
							<Translate value={title} />
							{hasClearButton &&
								<SelectionClearer />
							}
						</>
					}
				</PageTitle>
			}
		</>
	);
};

export default Title;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Title/index.tsx